<menu>
    <div class="col-lg-2 col-md-3 col-sm-12 col-xs-12 float-left" *ngIf='!accessDenied'>
        <h6 class="menu-headers"> SETUP </h6>

        <h6 class="cus-menus">
            <a [routerLink]="'dataEngine'" [routerLinkActive]="['lt-black','medium']">Data Engine</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'dataSource'" [routerLinkActive]="['lt-black','medium']">Data Location</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'recordFormat'" [routerLinkActive]="['lt-black','medium']">Data Mart</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'wizard'" [routerLinkActive]="['lt-black','medium']">Designer</a>
        </h6>

        <h6 class="menu-headers"> ANALYTICAL MODEL </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'cube'" [routerLinkActive]="['lt-black','medium']">Cube</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'dimension'" [routerLinkActive]="['lt-black','medium']">Dimension</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'measure'" [routerLinkActive]="['lt-black','medium']">Measure</a>
        </h6>

        <!-- <h6 class="cus-menus">
            <a [routerLink]="'valueStream'" [routerLinkActive]="['lt-black','medium']">Value Stream</a>
        </h6> -->


        <h6 class="menu-headers"> AUTHORIZATION </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'scope'" [routerLinkActive]="['lt-black','medium']">Scope</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'pageAuthorization'" [routerLinkActive]="['lt-black','medium']">Page Authorization</a>
        </h6>

        <h6 class="cus-menus">
            <a [routerLink]="'roleAuthorization'" [routerLinkActive]="['lt-black','medium']">Role Authorization</a>
        </h6>

        <h6 class="cus-menus">
            <a [routerLink]="'dimLvlPermissions'" [routerLinkActive]="['lt-black','medium']">Dimension Level Permissions
            </a>
        </h6>
        <!-- <h6 class="cus-menus">
            <a [routerLink]="'target'" [routerLinkActive]="['lt-black','medium']">Target</a>
        </h6> -->

        <h6 class="menu-headers"> CONFIGURATION </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'tenantConfiguration'" [routerLinkActive]="['lt-black','medium']">Tenant Configuration</a>
        </h6>
        <h6 class="cus-menus">
            <a [routerLink]="'uom'" [routerLinkActive]="['lt-black','medium']">UOM</a>
        </h6>


    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-left" *ngIf='accessDenied'>
        <h1 class="medium text-center">Access Denied !!!</h1>
    </div>
    <div class="col-lg-10 col-md-9 col-sm-12 col-xs-12 float-left b-l">
        <router-outlet></router-outlet>
    </div>
</menu>


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/adminPage.component.html